export const required = (value, fieldName) => {
  const valid = value && value.length > 0;
  const errorMessage = fieldName
    ? `O campo ${fieldName} é obrigatório`
    : "Este campo é obrigatório";
  return { valid, errorMsg: valid ? "" : errorMessage };
};

export const emailValidation = (value) => {
  const valid = /(^\w.*@[\w-]+\.\w)/.test(value);
  return { valid, errorMsg: valid ? "" : "E-mail inválido" };
};

export const phoneValidation = (value) => {
  value = value.replace(/[^\d]+/g, "");
  const valid = /^([0])?[1-9]{2}(9)([0-9]{4})[0-9]{4}$/.test(value);
  return { valid, errorMsg: valid ? "" : "Telefone inválido" };
};

export const cpfValidation = (strCPF) => {
  strCPF = strCPF.replace(/[^\d]+/g, "");
  let Soma;
  let Resto;
  Soma = 0;
  let valid = true;
  if (
    strCPF === "00000000000" ||
    strCPF === "11111111111" ||
    strCPF === "22222222222" ||
    strCPF === "33333333333" ||
    strCPF === "44444444444" ||
    strCPF === "55555555555" ||
    strCPF === "66666666666" ||
    strCPF === "77777777777" ||
    strCPF === "88888888888" ||
    strCPF === "99999999999"
  ) {
    valid = false;
  }

  if (strCPF.length !== 11) {
    valid = false;
  }

  for (let i = 1; i <= 9; i++) {
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
  }
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) {
    Resto = 0;
  }
  if (Resto !== parseInt(strCPF.substring(9, 10))) {
    valid = false;
  }

  Soma = 0;
  for (let i = 1; i <= 10; i++) {
    Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
  }
  Resto = (Soma * 10) % 11;

  if (Resto === 10 || Resto === 11) {
    Resto = 0;
  }
  valid = valid && Resto === parseInt(strCPF.substring(10, 11));
  return { valid, errorMsg: valid ? "" : "CPF inválido" };
};

export const cnpjValidation = (cnpj) => {
  let valid = true;
  cnpj = cnpj.replace(/[^\d]+/g, "");

  if (cnpj === "") {
    valid = false;
  }

  if (cnpj.length !== 14) {
    valid = false;
  }

  if (
    cnpj === "00000000000000" ||
    cnpj === "11111111111111" ||
    cnpj === "22222222222222" ||
    cnpj === "33333333333333" ||
    cnpj === "44444444444444" ||
    cnpj === "55555555555555" ||
    cnpj === "66666666666666" ||
    cnpj === "77777777777777" ||
    cnpj === "88888888888888" ||
    cnpj === "99999999999999"
  ) {
    valid = false;
  }

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  const digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i -= 1) {
    soma += parseInt(numeros.charAt(tamanho - i)) * pos;
    pos -= 1;
    if (pos < 2) {
      pos = 9;
    }
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== +digitos.charAt(0)) {
    valid = false;
  }
  tamanho = tamanho + 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i -= 1) {
    soma += parseInt(numeros.charAt(tamanho - i)) * pos;
    pos -= 1;
    if (pos < 2) {
      pos = 9;
    }
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== +digitos.charAt(1)) {
    valid = false;
  }
  return { valid, errorMsg: valid ? "" : "CNPJ Inválido" };
};

export const cpfCnpjValidation = (value) => {
  const valid = cpfValidation(value).valid || cnpjValidation(value).valid;
  return { valid, errorMsg: valid ? "" : "CPF / CNPJ Inválido" };
};

export const nameValidation = (value) => {
  const valid = /^[a-zA-Zà-úÀ-Ú]{2,40}(?: +[a-zA-Zà-úÀ-Ú]{2,40})+$/.test( //NOSONAR
    value
  );
  return { valid, errorMsg: valid ? "" : "Digite seu nome completo" };
};

export const validateMinLength = (value, minLength = 50) => {
  const valid = value.length >= minLength;

  return {
    valid,
    errorMsg: valid
      ? ""
      : `Este campo é obrigatório e deve ter pelo menos ${minLength} caracteres`,
  };
};

export const validateMaxLength = (value, maxLength = 2000) => {
  const invalid = value.length > maxLength;

  return {
    invalid,
    errorMsg: invalid
    ? `Este campo não pode conter mais que ${maxLength} caracteres`
    : "",
  };
};
